import React, {Component, Fragment} from 'react'
import {Row, Col, Button} from 'reactstrap'
import autobind from 'auto-bind'

import Modal from './modals/edit'

export default class extends Component {
    constructor(props) {
        super(props)
        autobind(this)

        this.state = {
            modalOpen: false,
        }
    }

    toggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen,
        })
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col>
                        <h1 className="mb-0">References</h1>
                        <h4 className="text-muted">
                            Click below to manage references.
                        </h4>
                        <p className="text-muted">
                            This is not the preferred way to manage reference
                            between data models - it avoids embedding of
                            documents at the cost of performance.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button onClick={this.toggleModal}>
                            Manage References
                        </Button>
                        <hr />
                    </Col>
                </Row>
                {this.state.modalOpen ? (
                    <Modal
                        toggle={this.toggleModal}
                        open={this.state.modalOpen}
                        {...this.props}
                    />
                ) : null}
            </Fragment>
        )
    }
}
